import generateUUID from './generateUUID';
// import { Component } from 'react'
// import { useForm } from 'react-hook-form';
// import { useStateMachine } from 'little-state-machine';
// import updateAction from '../components/MultipartForm/updateAction';

//
export type MultipartFormProps = {
  stepComponents: any[]; // TODO: add step type
  doneScreenContent: React.ReactElement;
};
export type MultipartFormState = {
  stepIndex: number;
  done: boolean;
};

export type MPFStepProps = {
  label: string;
  mobileLabel?: string;
  reviewMode: boolean;
  next: () => void;
  prev: () => void;
  // goToStep is the actual function that changes things
  goToStep: (stepIndex: number, name?: string) => void;
  // returnToStep is added in ReviewStep and has the indices hardcoded
  returnToStep: () => void;
  setDone?: (done: boolean) => void; // flag the entire multi-part form as complete
};
export type MPFReviewStepProps = MPFStepProps & {
  steps: any[]; // TODO: use types
};

export type MPFStepFooterObject = {
  label: string;
  status: 'active' | 'inactive' | 'completed';
  mobileLabel?: string;
};

export type TypeaheadOptions = { label: string; value: string; }[];

export type StudentData = {
  firstName: string;
  lastName: string;
  grade: string;
  dob: string; // Stored in lsm data as a string (e.g. 2012-12-31)
  email: string;
  phone: string;
  school: TypeaheadOptions;
  streetAddress: string;
  city: string;
  postalCode: string;
  province: string;
  // TODO: add the rest

  // so the form data rendering works properly when removing students
  uuid: string;
};

export const generateBlankStudentData = (): StudentData => {
  // Blank student
  return {
    firstName: '',
    lastName: '',
    grade: '',
    dob: '',
    email: '',
    phone: '',
    school: [{ label: '', value: '' }],
    streetAddress: '',
    city: '',
    postalCode: '',
    province: '',
    uuid: generateUUID(),
  };
  // Sample student
  // return {
  //   firstName: 'foo',
  //   lastName: 'bar',
  //   grade: 'Grade 5',
  //   email: 'foo@bar.com',
  //   phone: '111-222-3333',
  //   school: [{ label: 'Preston High School', value: '0016g000014F2JqAAK' }],
  //   streetAddress: '1234 Main St',
  //   city: 'Cambridge',
  //   postalCode: 'N1R 1A1',
  //   province: 'ON',
  //   uuid: generateUUID(),
  // };
}

export type TSubmissionStatus = 'loading' | 'success' | 'fail' | 'not-submitted';

export type TSelectOption = {
  label: string;
  value: string;
};

//
// abstract class MultipartFormStepComponent<P = {}, S = {}, SS = any> extends Component<P, S, SS> {
//   abstract test(): string
// }
// type MultipartFormStepProps = {
//   first: string,
//   last: string,
// }
// type MultipartFormStepState = {
//   fullName: string,
// }
// class MultipartFormStep extends MultipartFormStepComponent<MultipartFormStepProps, MultipartFormStepState> {
//   constructor(props: MultipartFormStepProps) {
//     super(props);
//     this.state = {
//       fullName: `${props.first} ${props.last}`
//     }
//   }



//   test() {
//     const { fullName } = this.state
//     return fullName
//   }
// }
